var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('Toolbar'),_c('v-main',{staticClass:"v-sheet theme--light"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer'),_c('BackofficeChatbot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }